import ResignCertificates from "../../../../components/company/workforce/resigned/ResignCertificates";

export default function ExperienceLetterPage(){
    return <ResignCertificates title="Experience Letter"/>
}